/* eslint-disable sonarjs/no-duplicate-string */

import type { IFontPresents, TFontPreset, TFontWeightValid, TView } from './models';

export const VIEWS = [
    // Title
    'xlarge',
    'large',
    'medium',
    'small',
    'xsmall',
    // Text
    'primary-large',
    'primary-medium',
    'primary-small',
    'secondary-large',
    'secondary-medium',
    'secondary-small',
    'component',
    'component-secondary',
    'caps',
] as const;

export const FONT_PRESETS = [
    // Text
    'primaryLarge',
    'primaryNormal',
    'primarySmall',
    'secondaryLarge',
    'secondaryNormal',
    'secondarySmall',
    'component',
    'component-secondary',
    'caps',
    // Title styrene
    'styreneXLarge',
    'styreneLarge',
    'styreneNormal',
    'styreneSmall',
    'styreneXSmall',
    // Title system
    'systemXLarge',
    'systemLarge',
    'systemNormal',
    'systemSmall',
    'systemXSmall',
] as const;

export const TAGS = [
    /* Текст */
    'p',
    /* SEO */
    'span',
    'div',
    /* Заголовки */
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    /* Формы */
    'label',
    /* SVG */
    'text',
    /* Жирность */
    'strong',
] as const;

/** @deprecated используйте 'light' (вместо 'white') или 'dark' (вместо 'black', 'blue') */
export const THEMES_OLD = ['white', 'black', 'blue'] as const;
export const THEMES_VALID = ['light', 'dark'] as const;
export const KINDS = ['green', 'red', 'caption'] as const;
export const TRANSFORMS = ['capitalize', 'lowercase', 'uppercase'] as const;
export const FONT_SIZES = [11, 12, 13, 14, 16, 18, 20, 22, 24, 30, 32, 40, 48, 64] as const;
export const FONT_WEIGHTS_OLD = [3, 4, 5, 6, 7] as const;
export const FONT_WEIGHTS_VALID = [300, 400, 500, 600, 700] as const;
export const LINE_HEIGHTS = [16, 18, 20, 22, 24, 26, 32, 36, 40, 48, 52, 64] as const;
// Совпадает с дефолтом в файле styles.css
export const defaultFontSize = 16;
export const defaultLineHeight = 1.4 as const;
export const DEFAULT_FONT_WEIGHT = 400;
export const defaultTheme = 'light';

export const fontWeightsMap: Record<number, TFontWeightValid> = {
    3: 300,
    4: 400,
    5: 500,
    6: 600,
    7: 700,
};

export const viewMap: Record<TView, TFontPreset> = {
    component: 'component',
    'component-secondary': 'component-secondary',
    caps: 'caps',
    'primary-large': 'primaryLarge',
    'primary-medium': 'primaryNormal',
    'primary-small': 'primarySmall',
    'secondary-large': 'secondaryLarge',
    'secondary-medium': 'secondaryNormal',
    'secondary-small': 'secondarySmall',
    xlarge: 'systemXLarge',
    large: 'systemLarge',
    medium: 'systemNormal',
    small: 'systemSmall',
    xsmall: 'systemXSmall',
};

export const fontPresets: IFontPresents = {
    // Text
    primaryLarge: {
        // @mixin paragraph_primary_large;
        fontSize: 18,
        lineHeight: 24,
        fontWeight: 400,
    },
    primaryNormal: {
        // @mixin paragraph_primary_normal;
        fontSize: 16,
        lineHeight: 24,
        fontWeight: 400,
    },
    primarySmall: {
        // @mixin paragraph_primary_small;
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 400,
    },
    secondaryLarge: {
        // @mixin paragraph_secondary_large;
        fontSize: 13,
        lineHeight: 16,
        fontWeight: 400,
    },
    secondaryNormal: {
        // @mixin paragraph_secondary_normal;
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 400,
    },
    secondarySmall: {
        //  @mixin paragraph_secondary_small;
        fontSize: 11,
        lineHeight: 16,
        fontWeight: 400,
    },
    component: {
        fontSize: 16,
        lineHeight: 20,
        fontWeight: 400,
    },
    'component-secondary': {
        fontSize: 14,
        lineHeight: 18,
        fontWeight: 400,
    },
    caps: {
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 500,
        letterSpacing: 125,
        textTransform: 'uppercase',
    },
    // Title styrene
    styreneXLarge: {
        // @mixin headline_xlarge;
        fontSize: 48,
        lineHeight: 64,
        fontWeight: 500,
    },
    styreneLarge: {
        // @mixin headline_large;
        fontSize: 40,
        lineHeight: 48,
        fontWeight: 500,
    },
    styreneNormal: {
        // @mixin headline_normal;
        fontSize: 32,
        lineHeight: 40,
        fontWeight: 500,
    },
    styreneSmall: {
        // @mixin headline_small;
        fontSize: 24,
        lineHeight: 32,
        fontWeight: 500,
    },
    styreneXSmall: {
        // @mixin headline_xsmall;
        fontSize: 20,
        lineHeight: 24,
        fontWeight: 500,
    },
    // Title system
    systemXLarge: {
        // @mixin headline-system_xlarge;
        fontSize: 48,
        lineHeight: 52,
        fontWeight: 700,
    },
    systemLarge: {
        // @mixin headline-system_large;
        fontSize: 40,
        lineHeight: 48,
        fontWeight: 700,
    },
    systemNormal: {
        // @mixin headline-system_normal;
        fontSize: 30,
        lineHeight: 36,
        fontWeight: 700,
    },
    systemSmall: {
        // @mixin headline-system_small;
        fontSize: 22,
        lineHeight: 26,
        fontWeight: 700,
    },
    systemXSmall: {
        // @mixin headline-system_xsmall;
        fontSize: 18,
        lineHeight: 22,
        fontWeight: 700,
    },
};
